import { usePhieuXuatKhoMutation } from './usePhieuXuatKhoMutation';
import { usePhieuXuatKhoImport } from './usePhieuXuatKhoImport';
import { usePhieuXuatKhoSearchContext } from './search-context';
import { usePhieuXuatKhoTable } from './usePhieuXuatKhoTable';
import type { PhieuXuatKho } from '@/types/schemas';

export const usePhieuXuatKhoPage = () => {
  const { isExporting, isImportDialogOpen, openImportDialog, closeImportDialog, transactionOptions } =
    usePhieuXuatKhoSearchContext();
  const tableState = usePhieuXuatKhoTable();
  const importState = usePhieuXuatKhoImport({
    closeImportDialog,
    refreshData: tableState.crud.refreshData,
    transactionOptions
  });
  const mutationState = usePhieuXuatKhoMutation({
    detail: tableState.crud.detail,
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    handleCloseDelete: tableState.form.handleCloseDelete,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData
  });

  return {
    searchDialog: tableState.searchDialog,
    importDialog: {
      open: isImportDialogOpen,
      isImporting: importState.isImporting,
      openDialog: openImportDialog,
      closeDialog: closeImportDialog,
      onSubmit: importState.handleImportFromExcel
    },
    importErrorDialog: importState.importErrorDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    multipleFormDialog: tableState.multipleFormDialog,
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      onConfirm: mutationState.handleDelete
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    table: tableState.table,
    detailTable: {
      rows: tableState.selection.selectedObj ? (tableState.crud.detail as PhieuXuatKho | null)?.chi_tiet || [] : []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
